<app-confirm-dialog
    [visible]="!!pendingEnquiryForm"
    variant="secondary"
    heading="Confirm Enquiry"
    message="Are you sure you want to submit this enquiry?"
    cancelText="No"
    (confirmed)="confirmSubmit()"
    (cancelled)="cancelSubmit()">
</app-confirm-dialog>

<div class="enquiryMain">
    <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
        styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
        animationDuration=".5s"></p-progressSpinner></div>
    <app-public-header  [company]="company" [branch]="branch"></app-public-header>

    <div class="enquiryBody">
        <div>
            <h1 class="enquiryHeading">Add Enquiry</h1>
        </div>
        <div class="card , formMain">
            <div class="apiResponceMessage" *ngIf="isMessage">
                <div style="position: relative;">
                    <p-message class="errors" *ngIf="isMessage && isError" severity="error" text="{{message}}"></p-message>
                    <p-message class="inquiry-successs" *ngIf="isMessage && isSuccess" severity="success" text="{{message}}"></p-message>
                    <span   style="position: absolute; right: 6px; top: 0; cursor: pointer; font-size: 17px; color: #ddd;" (click)="errorMsgClose()" *ngIf="isError || isSuccess">
                        <i class="fa fa-times"></i>
                    </span>
                </div>
            </div>


            <form class="form" #form="ngForm" (ngSubmit)="submit(form)">
                <div>
                    <div class="ui-inputgroup inputMain">
                        <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-user"
                                aria-hidden="true"></i></span>
                        <input class="input" type="text" id="name" #name="ngModel" [(ngModel)]="fullName" required
                            pattern="[A-Za-z ]+" autocomplete="off" placeholder="Name *" maxlength="100" name="name"
                            [ngClass]="name.invalid && (name.dirty || name.touched) ?  'errorInput' : '' ">
                        <div *ngIf="name.invalid && (name.dirty || name.touched)" class="errorFixNew">
                            <div *ngIf="name.errors.required" class="errorShow">
                                Please enter your name.
                            </div>
                            <div *ngIf="name.errors.pattern" class="errorShow">
                                Your name must contain only letters.
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="ui-inputgroup  inputMain">
                        <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-envelope"
                                aria-hidden="true"> </i></span>
                        <input maxlength="256" class="input" #email="ngModel"
                            [ngClass]="email.invalid && (email.dirty || email.touched) ? 'errorInput' : '' "
                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" [(ngModel)]="emailAdress" required
                            type="text" id="Email" autocomplete="off" placeholder="Email *" name="email">
                            <div class="errorFixNew">
                                <ng-template [ngIf]="email.invalid && (email.dirty || email.touched)">
                                    <div>
                                        <div *ngIf="email.errors.required" class="errorShow">
                                            Please enter your email address.
                                        </div>
                                        <div *ngIf="email.errors.pattern" class="errorShow">
                                            Please enter a valid email. e.g. (john@example.com)
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                    </div>
                </div>

                <div>
                    <div class="ui-inputgroup  inputMain">
                           <app-phone-input
                                placeholder="Mobile *"
                                [(phoneNumber)]="mobile"
                                [initialCountry]="'PK'"
                                (validNumber)="formattedNumber = $event"
                                (formattedForSaving)="mobile = $event"
                                style="max-width: 600px; margin: auto; align-items: center;">
                            </app-phone-input>
                            <div *ngIf="!mobile" class="validation-error" style="color: red; text-align: center; margin-top: 8px;">
                                Please enter mobile number
                            </div>
                    </div>
                </div>
                <div class="ui-inputgroup  inputMain">
                    <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-map-marker"
                            aria-hidden="true"></i></span>
                    <input class="input" type="text" id="street" [(ngModel)]="address" autocomplete="off"
                        placeholder="Street*" name="address">
                </div>
                <div class="genderMain">
                    <span class="genderh1">Gender:</span>
                    <div class="genderDiv">
                        <div class="radioMain">
                            <p-radioButton name="gender" value="M" label="Male" id="gender" [(ngModel)]="gender">
                            </p-radioButton>
                        </div>
                        <div>
                            <p-radioButton name="gender" value="F" label="Female" id="gender" [(ngModel)]="gender">
                            </p-radioButton>
                        </div>
                    </div>
                </div>
                <!-- <div class="ui-g-12">
                    <div class="ui-g">
                        <span>Have you Been Covid Vaccinated ?</span>
                        <div class="covidMainDiv">
                            <div>
                                <p-radioButton name="question1" isVaccinated="true" id="isVaccinated" value="YES"
                                    label="YES" [(ngModel)]="isVaccinated">
                                </p-radioButton>
                            </div>
                            <div class="ui-g-6">
                                <p-radioButton name="question1" id="isVaccinated" value="NO" label="NO"
                                    [(ngModel)]="isVaccinated">

                                </p-radioButton>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="calenderMain">
                    <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                        placeholder="Expected joining" [(ngModel)]="expectedJoining" name="expectedJoining" [inline]="false"
                        dateFormat="dd/mm/yy" [showIcon]="true">
                    </p-calendar>
                </div>
                <div class="saveMain">
                    <button
                        class="saveButton p-button submitButton p-widget p-state-defaultp-corner-all">
                        <span class="ui-button-text ui-c">
                            <i class="fa fa-save" aria-hidden="true"></i> &nbsp;Save
                        </span>
                    </button>
                </div>
            </form>
        </div>
    </div>

    <app-public-footer [branch]="branch"></app-public-footer>

</div>